<template>
  <div style="width: 100%;" v-loading.body="loading" class="vendor-history-report">
    <el-row type="flex" align="middle" justify="end" class="headerRow">
      <el-col>
        <el-row type="flex" align="middle" justify="start" style="font-size: 1.5em;">
          ACCOUNTS PAYABLE AGING REPORT
        </el-row>
      </el-col>
      <el-col class="small">
          <a @click="showJson = ! showJson">.&nbsp;</a>
      </el-col>
      <el-col>
        <el-row type="flex" align="middle" justify="end">
          <el-button plain @click="generateReport" :disabled="disableReportRun">
            Run report
          </el-button>
        </el-row>
      </el-col>
    </el-row>
    <el-row type="flex" align="middle" justify="end" class="headerRow">
      <el-col>
        <el-row type="flex" align="middle" justify="start" style="font-size: 1.2em;">
          Report Options
        </el-row>
      </el-col>
    </el-row>

    <el-row type="flex" align="middle" justify="start" class="headerRow">
      <el-col :span="3" class="right">
        Report Style
      </el-col>
      <el-col :span="4">
        <el-radio-group v-model="reportOptions.report_type" @change="updateReportType">
          <el-radio-button label="0">Summary</el-radio-button>
          <el-radio-button label="1">Detail</el-radio-button>
        </el-radio-group>
      </el-col>
    </el-row>

    <el-row type="flex" align="middle" justify="start" class="headerRow">
      <el-col :span="3" class="right">
        Aging Type
      </el-col>
      <el-col :span="4">
        <el-radio-group v-model="reportOptions.date_type" @change="updateDateType">
          <el-radio-button label="0">Invoice Date</el-radio-button>
          <el-radio-button label="1">Due Date</el-radio-button>
        </el-radio-group>
      </el-col>
    </el-row>

    <el-row type="flex" align="middle" justify="start" class="headerRow">
      <el-col :span="3" class="right">
        Date
      </el-col>
      <el-col :span="4">
        <DateField
          id="date"
          name="date"
          ref="date"
          :dataoptions="{ 'data-type': 'date' }"
          v-model="reportOptions.date"
          @change="updateDate"
        />
      </el-col>
    </el-row>

    <el-row type="flex" align="middle" justify="start" class="headerRow mt-1">
      <el-col :span="3" class="right">
        Report Output
      </el-col>
      <el-col :span="4">
        <el-select v-model="reportFormat">
          <el-option
            v-for="opt in reportOutputFormats"
            :key="opt.value"
            :label="opt.label"
            :value="opt.value">
          </el-option>
        </el-select>
      </el-col>
    </el-row>
    <div class="clear"></div>
    <el-row type="flex" align="middle" justify="end" class="section">
      <el-col>
        <el-row type="flex" align="middle" justify="start">
          Vendor Selection
        </el-row>
      </el-col>
    </el-row>
    <el-row type="flex" align="middle" justify="start" class="headerRow">
      <el-col :span="24" :offset="1">
        <el-radio-group v-model="vendorQuickPick" @change="updateVendors" :disabled="loading || disableReportRun">
          <el-radio-button label="custom">Custom</el-radio-button>
          <el-radio-button label="all">All</el-radio-button>
        </el-radio-group>
      </el-col>
    </el-row>
    <el-row v-show="vendorQuickPick==='custom'" type="flex" align="top" justify="start" class="headerRow" style="background: #eef1f6;">
      <el-col :span="24" :offset="1">
        <el-transfer
          ref="vendorTransfer"
          v-model="reportOptions.vendors"
          :data="vendors"
          :titles="[ 'Unselected Vendors', 'Selected Vendors' ]"
          :props="{ key: 'id', label: 'display_name' }"
          filterable
          filter-placeholder="Search Vendors"
        >
        </el-transfer>
      </el-col>
    </el-row>
    <el-row type="flex" align="middle" justify="end" class="headerRow" style="background: #eef1f6;">
      <el-col></el-col>
      <el-button plain @click="generateReport" :disabled="disableReportRun">
        Run report
      </el-button>
    </el-row>
    <el-row v-if="showJson">
      <el-col>
        <textarea id="output" style="width: 100%; height: 500px;" v-model="prettyJson"></textarea>
      </el-col>
    </el-row>
    <el-row v-if="showJson">
      <el-col :span="1">
        <el-button plain @click="generateCustomReport" :disabled="disableReportRun">
          Run Customized Report
        </el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  /* eslint-disable no-unused-vars */
  import { mapGetters } from 'vuex'
  import { sortObjectByProperty } from '@/utils/helpers/ObjectSorting'
  import { reportMixins } from '@/Mixins/Reports'
  import DateField from '@/components/InputComponents/DatePicker.vue'
  import { getSimpleDate } from '@/utils/helpers/FormatDate'

  export default {
    name: 'APAgingReport',
    components: { DateField },
    mixins: [ reportMixins ],
    data () {
      return {
        reportOptions: {
          report_type: 1,
          date_type: 0,
          date: getSimpleDate(new Date(), 'yyyy-mm-dd'),
          vendors: []
        },
        vendorQuickPick: 'all',
        reportFormat: 'pdf',
        reportType: 'detail',
        jasperSettings: {
          reportServer: 'https://jasper.revolutiones.com:8443/jasperserver/rest_v2/reports/Revolution/Phoenix/',
          reportName: 'aging_report_detail'
        },
        reportOutputFormats: [
          { value: 'pdf', label: 'PDF' },
          { value: 'csv', label: 'CSV' }
        ],
        allCodes: {},
        allVendors: [],
        sortedVendors: [],     // Sorted data by accounts, transaction ID.  Needed for 90% of reports
        disableReportRun: false, // Disable run report button if false
        reportJson: undefined,
        prettyJson: undefined,
        showJson: false,
        reportNotif: undefined,
        collapseExpenses: false,
        loading: false
      }
    },

    computed: {
      ...mapGetters({
        getAddressById: 'getAddressById',
        getStateById: 'getStateById',
        getCityById: 'getCityById'
      }),
      username () { return this.$store.getters.getUser.username },
      vendors () {
        let vendors = []
        for (const i in this.allVendors) {
          const vendor = this.allVendors[i]
          vendor.display_name = vendor.code + ' - ' + vendor.name
          if (vendor.id && vendor.active) vendors.push(vendor)
        }
        return vendors
      }
    },

    methods: {
      resetComponent () {
        this.reportJson = this.sortedVendors = undefined
        this.clearStore()
      },
      clearStore () {
        // TODO
      },
      updateReportType (type) {
        if (Number(type) === 1) {
          this.jasperSettings.reportName = 'aging_report_detail'
          this.reportType = 'detail'
        } else {
          this.jasperSettings.reportName = 'aging_report_summary'
          this.reportType = 'summary'
        }
      },
      updateDateType (type) {
        this.reportOptions.date_type = Number(type)
      },
      updateDate (dt) {
        if (typeof dt !== 'undefined' && dt === '') {
          this.reportOptions.date = ''
        }
      },
      updateVendors (type) {
        if (!type) return false
        switch (type) {
          case 'none':
            this.disableReportRun = false
            this.reportOptions.vendors = []
            break
          case 'all':
            this.disableReportRun = false
            this.reportOptions.vendors = []
            break
          case 'custom':
            this.disableReportRun = false
            break
          default:
            return undefined
        }
        // The transfer table is one tick behind.  Force update now
        this.$forceUpdate()
        return true
      },

      buildVendorReport (sortedVendors) {
        return new Promise((resolve, reject) => {
          let json = {
            report: {
              report_title: (this.reportType === 'detail') ? 'AGED PAYABLES DETAIL' : 'AGED PAYABLES SUMMARY',
              report_name: (this.reportType === 'detail') ? 'ap_aging_details_cpa' : 'ap_aging_summary_cpa',
              aging_type: (Number(this.reportOptions.date_type) === 1) ? 'Due Date' : 'Invoice Date',
              printed_by: this.username,
              date_run: this.today(),
              date: this.reportOptions.date,
              company: this.allCodes.companies.length ? this.allCodes.companies[0].name : 'ACME COMMERCIALS',
              report_type: 'VENDOR',
              grand_total_unpaid_amount: 0,
              grand_total_0_to_30_days: 0,
              grand_total_31_to_60_days: 0,
              grand_total_61_to_90_days: 0,
              grand_total_gt_90_days: 0,
              grand_total_unpaid_amount_decimal: 0,
              grand_total_0_to_30_days_decimal: 0,
              grand_total_31_to_60_days_decimal: 0,
              grand_total_61_to_90_days_decimal: 0,
              grand_total_gt_90_days_decimal: 0,
              data: []
            }
          }

          // Put finished data here
          if (sortedVendors) {
            for (const [i, sortedVendor] of Object.entries(sortedVendors)) {
              const currentVendor = this.vendors.find((vend) => vend.id === i)

              let vendor = {}
              vendor.vendor_address = this.getVendorAddress(currentVendor)
              vendor.vendor_name = currentVendor.name
              vendor.total_unpaid_amount = 0
              vendor.total_0_to_30_days = 0
              vendor.total_31_to_60_days = 0
              vendor.total_61_to_90_days = 0
              vendor.total_gt_90_days = 0
              vendor.total_unpaid_amount_decimal = 0
              vendor.total_0_to_30_days_decimal = 0
              vendor.total_31_to_60_days_decimal = 0
              vendor.total_61_to_90_days_decimal = 0
              vendor.total_gt_90_days_decimal = 0
              vendor.vendor_name_title = 'Vendor Name'
              vendor.vendor_number_title = 'Vendor Address'
              vendor.vendor_totals_title = 'Vendor Total'
              if (this.reportType === 'detail') {
                vendor.transactions = []
              }

              for (const [key, transaction] of Object.entries(sortedVendor)) {
                let trnUnpaidAmount = parseFloat(transaction.unpaid) || 0
                let periodOneAmount = (Number(transaction.aging) < 31) ? trnUnpaidAmount : 0
                let periodTwoAmount = (Number(transaction.aging) > 30 && Number(transaction.aging) < 61) ? trnUnpaidAmount : 0
                let periodThreeAmount = (Number(transaction.aging) > 60 && Number(transaction.aging) < 91) ? trnUnpaidAmount : 0
                let periodFourAmount = (Number(transaction.aging) > 90) ? trnUnpaidAmount : 0

                if (this.reportType === 'detail') {
                  let vd = {
                    number: transaction.data.number,
                    date: transaction.data.date,
                    due_date: transaction.data.date_due,
                    unpaid_amount: this.intlNumberFormatterAging(trnUnpaidAmount),
                    unpaid_amount_0_30_days: this.intlNumberFormatterAging(periodOneAmount),
                    unpaid_amount_31_60_days: this.intlNumberFormatterAging(periodTwoAmount),
                    unpaid_amount_61_90_days: this.intlNumberFormatterAging(periodThreeAmount),
                    unpaid_amount_gt_90_days: this.intlNumberFormatterAging(periodFourAmount)
                  }
                  vendor.transactions.push(vd)
                }
                vendor.total_unpaid_amount_decimal += parseFloat(trnUnpaidAmount)
                vendor.total_0_to_30_days_decimal += parseFloat(periodOneAmount)
                vendor.total_31_to_60_days_decimal += parseFloat(periodTwoAmount)
                vendor.total_61_to_90_days_decimal += parseFloat(periodThreeAmount)
                vendor.total_gt_90_days_decimal += parseFloat(periodFourAmount)
              }

              if (this.reportType === 'detail') {
                vendor.transactions.sort(function (a, b) { if (a.date < b.date) { return -1 } return 0 })
              }

              json.report.grand_total_unpaid_amount_decimal += parseFloat(vendor.total_unpaid_amount_decimal)
              json.report.grand_total_0_to_30_days_decimal += parseFloat(vendor.total_0_to_30_days_decimal)
              json.report.grand_total_31_to_60_days_decimal += parseFloat(vendor.total_31_to_60_days_decimal)
              json.report.grand_total_61_to_90_days_decimal += parseFloat(vendor.total_61_to_90_days_decimal)
              json.report.grand_total_gt_90_days_decimal += parseFloat(vendor.total_gt_90_days_decimal)

              vendor.total_unpaid_amount = this.intlNumberFormatterAging(vendor.total_unpaid_amount_decimal)
              vendor.total_0_to_30_days = this.intlNumberFormatterAging(vendor.total_0_to_30_days_decimal)
              vendor.total_31_to_60_days = this.intlNumberFormatterAging(vendor.total_31_to_60_days_decimal)
              vendor.total_61_to_90_days = this.intlNumberFormatterAging(vendor.total_61_to_90_days_decimal)
              vendor.total_gt_90_days = this.intlNumberFormatterAging(vendor.total_gt_90_days_decimal)

              if (parseFloat(vendor.total_unpaid_amount_decimal) !== 0) {
                json.report.data.push(vendor)
              }
            }
            json.report.grand_total_unpaid_amount = this.intlNumberFormatterAging(json.report.grand_total_unpaid_amount_decimal)
            json.report.grand_total_0_to_30_days = this.intlNumberFormatterAging(json.report.grand_total_0_to_30_days_decimal)
            json.report.grand_total_31_to_60_days = this.intlNumberFormatterAging(json.report.grand_total_31_to_60_days_decimal)
            json.report.grand_total_61_to_90_days = this.intlNumberFormatterAging(json.report.grand_total_61_to_90_days_decimal)
            json.report.grand_total_gt_90_days = this.intlNumberFormatterAging(json.report.grand_total_gt_90_days_decimal)
            json.report.data.sort(function (a, b) { if (a.vendor_name.toUpperCase() < b.vendor_name.toUpperCase()) { return -1 } return 0 })
          }
          resolve(json)
        })
      },
      buildCsvData (sortedAccounts) {
        if (!sortedAccounts.data || !Array.isArray(sortedAccounts.data)) return false

        let detailedColumns = { 'Customer': 'vendor_name', 'Invoice': 'number', 'Invoice Date': 'date', 'Due Date': 'due_date', 'Unpaid Amount': 'unpaid_amount', '0-30 Days': 'unpaid_amount_0_30_days', '31-60 Days': 'unpaid_amount_31_60_days', '61-90 Days': 'unpaid_amount_61_90_days', '>90 Days': 'unpaid_amount_gt_90_days' }
        let summaryColumns = { 'Customer': 'vendor_name', 'Unpaid Amount': 'unpaid_amount', '0-30 Days': 'unpaid_amount_0_30_days', '31-60 Days': 'unpaid_amount_31_60_days', '61-90 Days': 'unpaid_amount_61_90_days', '>90 Days': 'unpaid_amount_gt_90_days' }

        let columnMap = (this.reportType === 'summary') ? summaryColumns : detailedColumns

        return new Promise((resolve, reject) => {
          let ledgerData = []

          if (this.reportType !== 'summary') {
            sortedAccounts.data.map(accountCode => {
              accountCode.transactions.map(row => {
                row.vendor_name = accountCode.vendor_name
                row.unpaid_amount = String(row.unpaid_amount.replaceAll(',', ''))
                row.unpaid_amount_0_30_days = String(row.unpaid_amount_0_30_days.replaceAll(',', ''))
                row.unpaid_amount_31_60_days = String(row.unpaid_amount_31_60_days.replaceAll(',', ''))
                row.unpaid_amount_61_90_days = String(row.unpaid_amount_61_90_days.replaceAll(',', ''))
                row.unpaid_amount_gt_90_days = String(row.unpaid_amount_gt_90_days.replaceAll(',', ''))
                ledgerData.push(row)
              })
            })
          } else {
            sortedAccounts.data.map(accountCode => {
              let row = accountCode
              row.vendor_name = accountCode.vendor_name
              row.unpaid_amount = String(row.total_unpaid_amount.replaceAll(',', ''))
              row.unpaid_amount_0_30_days = String(row.total_0_to_30_days.replaceAll(',', ''))
              row.unpaid_amount_31_60_days = String(row.total_31_to_60_days.replaceAll(',', ''))
              row.unpaid_amount_61_90_days = String(row.total_61_to_90_days.replaceAll(',', ''))
              row.unpaid_amount_gt_90_days = String(row.total_gt_90_days.replaceAll(',', ''))
              ledgerData.push(row)
            })
          }

          ledgerData.push({
            date: '',
            due_date: '',
            number: '',
            unpaid_amount: String(sortedAccounts.grand_total_unpaid_amount.replaceAll(',', '')),
            unpaid_amount_0_30_days: String(sortedAccounts.grand_total_0_to_30_days.replaceAll(',', '')),
            unpaid_amount_31_60_days: String(sortedAccounts.grand_total_31_to_60_days.replaceAll(',', '')),
            unpaid_amount_61_90_days: String(sortedAccounts.grand_total_61_to_90_days.replaceAll(',', '')),
            unpaid_amount_gt_90_days: String(sortedAccounts.grand_total_gt_90_days.replaceAll(',', '')),
            vendor_name: 'Grand Total'
          })

          this.disableReportRun = false
          let finalCsv = this.createCsv(ledgerData, columnMap)
          if (finalCsv) resolve(finalCsv)
          else reject('Could not build CSV.')
        })
      },
      generateReport () {
        this.loading = true
        this.disableReportRun = true

        if (this.reportOptions.date === '') {
          this.$notify({ title: 'Error', message: 'Date cannot be empty', type: 'error', offset: 0 })
          this.disableReportRun = false
          this.loading = false
          return false
        }

        if (this.reportFormat === 'csv') {
          this.getAgingReportData('reports/ap_aging_report')
            .then((resSorted) => {
              return resSorted.data
            })
            .then((results) => {
              return this.buildVendorReport(results)
            })
            .then((resReport) => {
              return this.buildCsvData(resReport.report)
            })
            .then((resCsv) => {
              this.prettyJson = resCsv
              this.loading = false
              this.createNotification('Success', 'CSV is Ready. ', 'success', false, true, this.reportTitle)
              return true
            })
            .catch(error => {
              this.loading = false
              console.log(error)
            })
        } else {
          this.getAgingReportData('reports/ap_aging_report')
            .then((resSorted) => {
              return resSorted.data
            })
            .then((results) => {
              return this.buildVendorReport(results)
            })
            .then(json => {
              this.reportJson = json
              this.prettyJson = JSON.stringify(json, null, 2)
              return this.getJsonUrl(json)
            })
            .then(resJsonUrl => {
              // PDF version of the report
              let report = this.jasperSettings.reportServer + this.jasperSettings.reportName + '.pdf?net.sf.jasperreports.json.source=' + resJsonUrl

              // HTML version of the report
              let preview = this.jasperSettings.reportServer + this.jasperSettings.reportName + '.html?net.sf.jasperreports.json.source=' + resJsonUrl
              return this.getReportUrl(report)
            })
            .then(reportUrl => {
              this.loading = false
              this.disableReportRun = false
              this.createNotification('Success', 'Report is Ready. ', 'success', reportUrl)
            })
            .catch(error => {
              this.loading = false
              this.disableReportRun = false
              console.log(error)
            })
        }
      },
      intlNumberFormatterAging (number) {
        if (typeof number === 'string') return number
        if (typeof number !== 'number' && !isNaN(Number(number))) return number

        let locale = 'en-us'
        let options = {
          style: 'decimal',
          useGrouping: true,
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }

        let result = new Intl.NumberFormat(locale, options).format(number)

        // -0 should be just 0
        if (result === '-0' || result === '-0.00') {
          result = new Intl.NumberFormat(locale, options).format(0)
        }

        return result
      },

      getVendorAddress (vendor) {
        if (vendor) {
          const addressLists = [ 'address_selected', 'address_contact', 'address_billing', 'address_mailing' ]
          for (let i = 0; i < addressLists.length; i++) {
            const v = vendor[addressLists[i]] || undefined
            let ven

            if (!v) {
              return undefined
            } else if (!isNaN(v)) {
              ven = this.getAddressById(v)
            } else if (typeof v === 'object' && v.line1) {
              ven = v
            } else {
              return undefined
            }

            let address = ven.line1
            address += ven.line2 ? ' ' + ven.line2 : ''
            address += ven.city ? ', ' + (isNaN(ven.city) ? ven.city : this.getCityById(ven.city).name) : ''
            address += ven.state ? ', ' + (isNaN(ven.state) ? ven.state : this.getStateById(ven.state).code) : ''
            address += ven.postal ? '  ' + ven.postal : ''
            return address
          }
        } else {
          return ''
        }
      }
    },

    created () {
      // Load data to be used for validation
      this.loading = true
      this.disableReportRun = true
      // Get Vendors
      this.getAllVendors()
        .then(response => {
          if (!response || !Array.isArray(response)) return false
          this.allVendors = sortObjectByProperty(response, 'code')
          this.disableReportRun = false
        })
        .catch(error => {
          console.log(error)
        })
        .finally(() => {
          this.loading = false
          this.disableReportRun = false
        })

      if (!this.$store.getters.getAllCities.length) {
        this.$store.dispatch('fetchCitiesWithQuery', { page_size: 200 })
      }
      this.$store.dispatch('fetchAllCompanies')
        .then((response) => {
          this.allCodes.companies = sortObjectByProperty(response, 'code')
        })
    },

    beforeDestroy () {
      this.resetComponent()
    }
  }

</script>
<style scoped>
  .small { font-size: 8px; }
  .right { float: right; text-align: right; padding: 0px 5px; }
  .left { float: left; text-align: left; padding: 0px 5px; }
  .selectRow { padding: 0px 20px; }
  .section { padding: 40px 20px 0px;  }
  .headerRow { padding: 15px 20px 0px; }
  .m-top-20 { margin-top: 20px; }
  .m-right-20 { margin-right: 20px; }
</style>
<style>
  .el-select { display: block; }
  .el-transfer-panel { width:36% !important; max-width: 350px !important; }
  .el-transfer-panel__body { min-height: 400px; }
  .el-transfer-panel__list { min-height: 360px; padding: 6px 0 18px 0px !important; }
  .el-transfer-panel .el-transfer-panel__empty { text-transform: capitalize; }
  .vendor-history-report .b-form-datepicker .btn-sm {
    right: 30px;
    z-index: 3;
  }
  /* border: 1px solid #d1dbe5; box-shadow: 0 2px 4px rgba(0,0,0,.12),0 0 6px rgba(0,0,0,.04); display: inline-block; width: 30%; position: relative; height: 500px; */
</style>


// WEBPACK FOOTER //
// src/components/Reports/APAgingReport.vue